import React, { useState, useEffect } from 'react';
import { urlFileAsync } from '../services/fileUrl';

/**
 * FileMedia
 * Rende <img> o <video> di un file protetto, ottenendo il token
 * temporaneo prima di impostare src. Sostituisce l'uso diretto di
 * urlFile() dentro i tag media, ora che l'URL si ottiene in modo async.
 *
 * Props:
 *  - url      percorso pubblico del file
 *  - tipo     'img' | 'video'   (default 'img')
 *  - alt, className, ...resto   inoltrate al tag
 */
const FileMedia = ({ url, tipo = 'img', alt = '', className, ...resto }) => {
    const [src, setSrc] = useState(null);
    const [errore, setErrore] = useState(false);

    useEffect(() => {
        let attivo = true;
        setErrore(false);
        setSrc(null);

        urlFileAsync(url)
            .then((finale) => { if (attivo) setSrc(finale); })
            .catch(() => { if (attivo) setErrore(true); });

        return () => { attivo = false; };
    }, [url]);

    if (errore) {
        return <div className={`file-media-errore ${className || ''}`}>File non disponibile</div>;
    }

    if (!src) {
        return <div className={`file-media-attesa ${className || ''}`} />;
    }

    if (tipo === 'video') {
        return <video src={src} className={className} controls {...resto} />;
    }

    return <img src={src} alt={alt} className={className} {...resto} />;
};

export default FileMedia;
